// /permitAdmin moved to /permitting. Old links and bookmarks land on the matching page:
//   /permitAdmin                              → /permitting
//   /permitAdmin/118                          → /permitting/118 (the request)
//   /permitAdmin/118/permits/200              → /permitting/118/permits/200 (the permit)
//   /permitAdmin/new                          → /permitting/new
// Anything else goes to the Permitting home rather than a page that doesn't exist.
export const permittingPathFor = (splat = '') => {
  const parts = splat.split('/').filter(Boolean);
  const id = (value?: string) => (value && /^\d+$/.test(value) ? value : undefined);
  if (parts.length === 0) return '/permitting';
  if (parts.length === 1 && parts[0] === 'new') return '/permitting/new';
  if (parts.length === 1 && id(parts[0])) return `/permitting/${parts[0]}`;
  if (parts.length === 3 && id(parts[0]) && parts[1] === 'permits' && id(parts[2])) {
    return `/permitting/${parts[0]}/permits/${parts[2]}`;
  }
  return '/permitting';
};
